import React, { Component } from 'react';

import './contextualMessage.css';

class ContextualMessage extends Component {
    render() {
        return (
            <div className={`ContextualMessage ${this.props.type}${this.props.typeText ? " text-" + this.props.typeText : ""}${this.props.compact ? " compact" : ""}`}>
                {this.props.showIcon === true ? <span className={`icon pr-2 fa`} /> : null}
                <div>
                {
                    this.props.children
                }
                </div>
                <div dangerouslySetInnerHTML={{__html: this.props.content}}></div>
            </div>
        );
    }
}

ContextualMessage.defaultProps = {
    showIcon: false,
    content: "",
    type: "warning",
    compact: false,
    typeText: ""
};

export default ContextualMessage;